import { PropsWithChildren, useContext, useEffect, useMemo, useState } from "react";
import { Button, Spinner, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    AddRegular,
    DeleteRegular
} from "@fluentui/react-icons";
import Grid from '@mui/material/Unstable_Grid2';
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import ScrollPanel from "components/layout/scroll-panel/scroll-panel";
import LoadingErrorBar from "components/common/loading-error-bar/loading-error-bar";
import LoadingSpinner from "components/common/loading-spinner/loading-spinner";
import { IApplicationRoleMembershipListProps } from "./application-role-membership-list.props";
import { ICommandBarItem } from "@interfaces/common.interfaces";
import { CallbackButton } from "components/command-bar/callback-button/callback-button";
import CommandBar from "components/command-bar/command-bar";
import { IApplicationRoleMembership } from "@interfaces/settings/permissions.interfaces";
import ApplicationRoleMembershipGrid from "../application-role-membership-grid/application-role-membership-grid";
import Trimmed from "components/common/trimmed/trimmed";
import { PPAPermissions } from "lib/permissions";

const layoutStyles = makeStyles({
    mainWrapper: {
        //...shorthands.borderWidth('1px', '0'),
        ...shorthands.margin('1em', '1.5em')
    },
    spinner: {
        ...shorthands.margin('2em', 0)
    }
});


const defaultCommandBarItems: Array<ICommandBarItem> = [
    {
        id: 'add',
        placement: 'left',
        order: 1,
    },
    {
        id: 'delete',
        placement: 'left',
        order: 2,
        hidden: true,
    }
];

export default function ApplicationRoleMembershipList(props: IApplicationRoleMembershipListProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();
    const [selectedItems, setSelectedItems] = useState<Array<IApplicationRoleMembership>>([]);

    const commandBarItems = useMemo(() => {
        var buttons = defaultCommandBarItems.map(item => {
            switch (item.id) {
                case 'add':
                    return {
                        ...item,
                        component:
                            <CallbackButton
                                key={item.id}
                                icon={<AddRegular />}
                                label="add"
                                onClick={props.onAddApplicationRoleMembershipClick}
                                permission={PPAPermissions.UpdateApplicationRoleMembership} />
                    }
                case 'delete':
                    return {
                        ...item,
                        hidden: selectedItems.length === 0 ? true : false,
                        component:
                            <CallbackButton
                                key={item.id}
                                icon={<DeleteRegular />}
                                label="remove"
                                onClick={() => { props.onDeleteApplicationRoleMembershipClick(selectedItems) }}
                                permission={PPAPermissions.UpdateApplicationRoleMembership} />
                    }
                default:
                    return item;
            }
        });
        return buttons;
    }, [selectedItems]);

    const onSelectionChanged = (items: Array<IApplicationRoleMembership>) => {
        setSelectedItems(items);
    }

    return (
        <ScrollPanel
            fixed={<CommandBar items={commandBarItems} />}
            scroll={<>
                {props.loading &&
                    <Spinner
                        className={styles.spinner}
                        labelPosition="below"
                        label={t('loading')} />}
                {!props.loading &&
                    <ApplicationRoleMembershipGrid
                        items={props.applicationRoleMembership}
                        onSelectionChanged={onSelectionChanged} />
                }
            </>}
        />
    );
}